import {
  GET_ERRORS,
  GET_SHOPPINGCART_ORDERS,
  SET_ORDERS_LOADING
} from "../actions/types";

const initialState = {
  orders: null,
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_SHOPPINGCART_ORDERS:
      return {
        ...state,
        orders: action.payload,
        loading: false
      };
    case SET_ORDERS_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_ERRORS:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
